import { createSelector } from '@ngrx/store';
import { selectUtilData, selectUtilUi } from '../utils.selectors';

export const selectMaintenanceModeStatusFlag = createSelector(
    selectUtilData,
    (data) => data.genericAppData?.maintenanceMode ?? false
);

export const selectMaintenanceModeData = createSelector(
    selectUtilData,
    (data) => ({
        maintenanceMode: data.genericAppData?.maintenanceMode,
        maintenanceModeDisplayMssg:
            data.genericAppData?.maintenanceModeDisplayMssg
    })
);
